var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Container, Graphics } from "pixi.js";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
import { GridColor } from "../../../constants/GridColor";
import { eventsCanvas } from "../../../events/eventsCanvas";
import { GetBuildingGraphicIso } from "../../../graphics/GetBuildingGraphicIso";
import { selectAllExistingBuildingInfo, selectIsBuildingPlacedTemporarily, } from "../../../selectors/selectExistingBuildingInfo";
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { utilDrawGrid } from "../../../utils/graphics/utilDrawGrid";
import { utilGrid } from "../../../utils/grid/utilGrid";
import { utilBuildings } from "../../../utils/utilBuildings";
import { SceneLayer } from "../../scenes/SceneLayer";
import { actionBuildingsCancelPlacement, actionBuildingsMoveMove, actionBuildingsMoveUnstore, actionBuildingsTemporaryMove, actionBuildingsTemporaryPlacement, actionBuildingsTemporaryUnstore, TypeActionBuildings, } from "../buildings/actionBuildings";
import { TypeBuildingAction } from "../buildings/reducerBuildings";
var Point = PIXI.Point;
var LayerPlayerBaseBuildingPlacement = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseBuildingPlacement, _super);
    function LayerPlayerBaseBuildingPlacement() {
        var _this = _super.call(this) || this;
        _this.update$ = new Subject();
        _this.buildingEnabledGraphics = new Graphics();
        _this.buildingDisabledGraphics = new Graphics();
        _this.buildingInactiveGraphics = new Graphics();
        _this.display = new Container();
        _this.gridObject = {
            id: 1,
            x: 0,
            xExtent: 0,
            y: 0,
            yExtent: 0,
        };
        _this.floatOffset = 15;
        _this.isFloating = false;
        _this.update = function (props) {
            if (props.targetBuilding.building != undefined) {
                _this.updateInteractions(props);
            }
            else {
                _this.cleanUp();
            }
        };
        _this.mapState = function (state) { return ({
            deps: state.dependencies,
            existingBuildings: selectAllExistingBuildingInfo(state),
            expansionInfo: selectExpansionInfo(state),
            isPlacedTemporarily: selectIsBuildingPlacedTemporarily(state),
            targetBuilding: state.playerBase.buildings,
        }); };
        _this.mapDispatch = function (dispatch) { return ({
            onFinishPlacement: function (action, building, premium) {
                var isPlacementValid = !_this.buildingDisabledGraphics.visible && !_this.buildingInactiveGraphics.visible;
                switch (action) {
                    case TypeBuildingAction.Construct:
                        return dispatch(actionBuildingsTemporaryPlacement(building, isPlacementValid, premium));
                    case TypeBuildingAction.Move:
                        return dispatch(actionBuildingsTemporaryMove(building, isPlacementValid));
                    case TypeBuildingAction.Unstore:
                        return dispatch(actionBuildingsTemporaryUnstore(building, isPlacementValid));
                    default:
                        return dispatch(actionBuildingsCancelPlacement());
                }
            },
            onMove: function (action, building) {
                switch (action) {
                    case TypeBuildingAction.Move:
                        return dispatch(actionBuildingsMoveMove(building));
                    case TypeBuildingAction.Unstore:
                        return dispatch(actionBuildingsMoveUnstore(building));
                    default:
                        return dispatch(actionBuildingsCancelPlacement());
                }
            },
        }); };
        _this.getIsoObject = function (obj) { return (__assign({}, _this.gridObject, { display: _this.display })); };
        _this.getObjects = function () { return [_this.display]; };
        _this.updateInteractions = function (props) {
            var action = props.targetBuilding.action;
            if (props.targetBuilding.building && props.targetBuilding.building.proto) {
                _this.flipped = props.targetBuilding.building.proto.flipped;
            }
            if (action === TypeBuildingAction.Construct) {
                _this.updateInteractionForAction(props, TypeActionBuildings.StartPlacement, _this.startConstruct, TypeActionBuildings.FinishPlacement);
            }
            if (action === TypeBuildingAction.Move) {
                _this.updateInteractionForAction(props, TypeActionBuildings.StartMove, _this.startMove, TypeActionBuildings.FinishMove);
            }
            if (action === TypeBuildingAction.Unstore) {
                _this.updateInteractionForAction(props, TypeActionBuildings.StartUnstoreBuilding, _this.startConstruct, TypeActionBuildings.FinishUnstoreBuilding);
            }
        };
        _this.updateInteractionForAction = function (props, typeStart, startCallback, typeFinish) {
            var type = props.targetBuilding.type;
            if (type === typeStart) {
                startCallback(props);
            }
            else if (type === TypeActionBuildings.Temporary) {
                _this.stopListening();
            }
            else if (type === TypeActionBuildings.Move) {
                _this.startListeningMove(props);
            }
            else if (type === TypeActionBuildings.Rotate) {
                _this.rotateGraphics(props);
                if (props.isPlacedTemporarily) {
                    _this.finishPlacement(props);
                }
            }
            else if (type === typeFinish) {
                _this.destroyDisplay();
            }
            else {
                _this.cleanUp();
            }
        };
        _this.rotateGraphics = function (props) {
            _this.destroyDisplay();
            _this.initDisplay(props, _this.gridObject);
            _this.checkBuildingPlacement(props);
            _this.redrawPlacementGraphics();
        };
        _this.startConstruct = function (props) {
            _this.cleanUp();
            _this.initDisplay(props);
            _this.checkBuildingPlacement(props);
            _this.redrawPlacementGraphics();
            _this.finishPlacement(props);
            _this.update$.next(true);
        };
        _this.startMove = function (props) {
            _this.cleanUp();
            _this.initDisplay(props);
            _this.update$.next(true);
            if (props.targetBuilding.building) {
                props.onMove(props.targetBuilding.action, props.targetBuilding.building);
            }
        };
        _this.startListeningMove = function (props) {
            _this.addFloatingImpression();
            _this.stopListening();
            _this.moveSub = eventsCanvas.mousemove$.subscribe(_this.createMoveHandler(props));
            _this.clickSub = eventsCanvas.click$.pipe(take(1)).subscribe(_this.createClickHandler(props));
            _this.update$.next(true);
        };
        _this.initDisplay = function (props, gridObject) {
            var buildingData = gridObject
                ? __assign({}, props.targetBuilding.building, { proto: __assign({}, props.targetBuilding.building.proto, { flipped: _this.flipped, posX: _this.gridObject.x, posY: _this.gridObject.y }) }) : props.targetBuilding.building;
            var graphic = GetBuildingGraphicIso(buildingData);
            if (graphic != undefined) {
                _this.graphic = graphic;
                _this.graphic.alpha = 0.9;
                _this.isFloating = false;
                _this.addFloatingImpression();
                _this.display.removeChildren();
                _this.display.addChild(_this.buildingEnabledGraphics, _this.buildingDisabledGraphics, _this.buildingInactiveGraphics);
                _this.display.addChild(graphic);
                _this.initGridObject(buildingData);
                var pos = utilGrid.mapToScreen(_this.gridObject.x, _this.gridObject.y);
                _this.display.position.set(pos.x, pos.y);
            }
        };
        _this.addFloatingImpression = function () {
            _this.triggerFloatingImpression(true);
        };
        _this.removeFloatingImpression = function () {
            _this.triggerFloatingImpression(false);
        };
        _this.triggerFloatingImpression = function (shouldFloat) {
            if (_this.graphic != undefined) {
                if (shouldFloat && !_this.isFloating) {
                    _this.graphic.position.y -= _this.floatOffset;
                    _this.isFloating = !_this.isFloating;
                }
                else if (!shouldFloat && _this.isFloating) {
                    _this.graphic.position.y += _this.floatOffset;
                    _this.isFloating = !_this.isFloating;
                }
            }
        };
        _this.initGridObject = function (buildingData) {
            _this.gridObject.x = buildingData.proto.posX;
            _this.gridObject.y = buildingData.proto.posY;
            _this.gridObject.xExtent = buildingData.proto.flipped
                ? buildingData.balancing.yExtent
                : buildingData.balancing.xExtent;
            _this.gridObject.yExtent = buildingData.proto.flipped
                ? buildingData.balancing.xExtent
                : buildingData.balancing.yExtent;
        };
        _this.cleanUp = function () {
            _this.stopListening();
            _this.destroyDisplay();
        };
        _this.stopListening = function () {
            if (_this.clickSub != undefined) {
                _this.clickSub.unsubscribe();
                _this.clickSub = undefined;
            }
            if (_this.moveSub != undefined) {
                _this.moveSub.unsubscribe();
                _this.moveSub = undefined;
            }
        };
        _this.destroyDisplay = function () {
            _this.buildingEnabledGraphics.visible = false;
            _this.buildingDisabledGraphics.visible = false;
            _this.buildingInactiveGraphics.visible = false;
            if (_this.graphic != undefined) {
                _this.graphic.parent.removeChild(_this.graphic);
                _this.graphic = undefined;
            }
        };
        _this.createMoveHandler = function (props) {
            _this.redrawPlacementGraphics();
            var occupiedTiles = utilBuildings.buildingsToOccupiedTileIds(props.existingBuildings, props.expansionInfo.baseSetup);
            var p = new Point();
            var handler = function (event) {
                if (event != undefined) {
                    p = event.data.getLocalPosition(_this, p);
                    var newPos = utilGrid.screenToMap(p.x, p.y);
                    if (newPos.x === _this.gridObject.x && newPos.y === _this.gridObject.y) {
                        return;
                    }
                    _this.gridObject.x = newPos.x;
                    _this.gridObject.y = newPos.y;
                }
                var pos = utilGrid.mapToScreen(_this.gridObject.x, _this.gridObject.y);
                _this.display.position.set(pos.x, pos.y);
                _this.checkBuildingPlacement(props, occupiedTiles);
                // Uncomment if there are other layers in Placement sorting group
                // this.update$.next(true);
            };
            handler();
            return handler;
        };
        _this.checkBuildingPlacement = function (props, occupiedTiles) {
            var fitsInGrid = utilGrid.fitsInGrid(_this.gridObject, props.expansionInfo.baseSetup, props.expansionInfo.unlockedExpansionIds);
            var occupiedTilesDefined = occupiedTiles
                ? occupiedTiles
                : utilBuildings.buildingsToOccupiedTileIds(props.existingBuildings, props.expansionInfo.baseSetup);
            var isSpaceFree = utilGrid.isSpaceFree(_this.gridObject, occupiedTilesDefined, props.expansionInfo.baseSetup);
            _this.buildingEnabledGraphics.visible = fitsInGrid && isSpaceFree;
            _this.buildingDisabledGraphics.visible = fitsInGrid && !isSpaceFree;
            _this.buildingInactiveGraphics.visible = !fitsInGrid;
        };
        _this.redrawPlacementGraphics = function () {
            _this.redrawPlacementGraphic(_this.buildingEnabledGraphics, GridColor.Positive);
            _this.redrawPlacementGraphic(_this.buildingDisabledGraphics, GridColor.Negative);
            _this.redrawPlacementGraphic(_this.buildingInactiveGraphics, GridColor.Negative);
        };
        _this.redrawPlacementGraphic = function (graphic, gridColor) {
            graphic.clear();
            graphic.alpha = 0.666;
            utilDrawGrid.draw(graphic, {
                fillColor: gridColor,
                sizeX: _this.gridObject.xExtent,
                sizeY: _this.gridObject.yExtent,
            });
        };
        _this.createClickHandler = function (props) {
            return function () {
                _this.removeFloatingImpression();
                _this.finishPlacement(props);
            };
        };
        _this.finishPlacement = function (props) {
            props.onFinishPlacement(props.targetBuilding.action, __assign({}, props.targetBuilding.building, { proto: __assign({}, props.targetBuilding.building.proto, { flipped: _this.flipped, posX: _this.gridObject.x, posY: _this.gridObject.y }) }), props.targetBuilding.premium);
        };
        _this.buildingDisabledGraphics.name = "PlacementDisabled";
        _this.buildingEnabledGraphics.name = "PlacementEnabled";
        _this.buildingInactiveGraphics.name = "PlacementInactive";
        return _this;
    }
    return LayerPlayerBaseBuildingPlacement;
}(SceneLayer));
export { LayerPlayerBaseBuildingPlacement };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseBuildingPlacement.ts
// module id = 2184
// module chunks = 3